import ToolboxElementType from '../../../../dataLayer/uiEnums/ToolboxElementType';

export default class DroppedInformation<T = any> {
  public constructor(
    public type: ToolboxElementType,
    public referenceKey: T,
    public config?: any
  ){}
}
